import { BaseCartClient, CartState, CreateSharedCartPayload, RawCartResponse, SharedCart } from "@core/types";
import { convertCartToSupaCart, convertSupaCartToCart } from "./converters";

import { supabaseClient } from "../supabase";

class CartClient extends BaseCartClient {
  async updateCart(cart: CartState, shippingZone: string): Promise<CartState | null> {
    const supaCart = convertCartToSupaCart(cart);

    const response = await this.instance.post<RawCartResponse | null>("/wp-json/parhato-api/v1/cart", {
      ...supaCart,
      shippingZone,
    });

    const data = response?.data;

    return data ? convertSupaCartToCart(data) : null;
  }
  async getSharedCartById(id: SharedCart["id"]): Promise<SharedCart | null> {
    const response = await supabaseClient.functions.invoke<SharedCart | null>("shared-cart", {
      body: { mode: "fetch", id },
    });

    if (response?.error) {
      throw new Error(response.error.message);
    }

    return response.data;
  }

  async createSharedCart(cart: CreateSharedCartPayload): Promise<SharedCart | null> {
    const response = await supabaseClient.functions.invoke<SharedCart | null>("shared-cart", {
      body: { mode: "create", ...cart }
    });

    if (response?.error) {
      throw new Error(response.error.message);
    }

    return response?.data;
  }

  async getAllSharedCarts(params?: { page?: number; perPage?: number }): Promise<SharedCart[] | null> {
    const response = await supabaseClient.functions.invoke<SharedCart[] | null>("shared-cart", {
      body: { mode: "fetch-all", page: params?.page ?? 1, perPage: params?.perPage ?? 10 },
    });

    if (response?.error) {
      throw new Error(response.error.message);
    }

    return response?.data;
  }
}

export default CartClient;
